import product1 from 'assets/img/miners/S19 Hydro.png';
import product2 from 'assets/img/miners/S19.jpg';
import product3 from 'assets/img/miners/S21 Hydro.png';
import product4 from 'assets/img/miners/S21.jpg';

export const productData = [
  {
    name: 'Bitmain Antminer S19J Pro',
    id: '1',
    price: 980.9,
    setupCosts: 70,
    isInStock: true,
    quantityInStock: 1230,
    files: [{ id: 1, src: product2 }],
    locations: ['Norway 1', 'Norway 2'],
    manufacturerName: 'ASIC',
    ths: 150,
    wattage: 3500
  },
  {
    name: 'Bitmain Antminer S21',
    id: '2',
    price: 2920.9,
    setupCosts: 70,
    isInStock: true,
    quantityInStock: 2330,
    files: [{ id: 1, src: product4 }],
    locations: ['Canada 1', 'Norway 2'],
    manufacturerName: 'ASIC',
    ths: 150,
    wattage: 3500
  },
  {
    name: 'Bitmain Antminer S19 Hydro Pro',
    id: '3',
    price: 1208.9,
    setupCosts: 70,
    isInStock: true,
    quantityInStock: 230,
    locations: ['Norway 1', 'Norway 1'],
    files: [{ id: 1, src: product3 }],
    manufacturerName: 'ASIC',
    ths: 150,
    wattage: 3500
  },
  {
    name: 'Bitmain Antminer S21 Pro',
    id: '4',
    price: 3700.9,
    setupCosts: 70,
    isInStock: true,
    quantityInStock: 3219,
    files: [{ id: 1, src: product4 }],
    locations: ['Canada 1', 'Norway 2'],
    manufacturerName: 'ASIC',
    ths: 150,
    wattage: 3500
  },
  {
    name: 'Bitmain Antminer S19 Hydro',
    id: '5',
    price: 959.9,
    setupCosts: 70,
    isInStock: true,
    quantityInStock: 30,
    files: [{ id: 1, src: product1 }],
    locations: ['Norway 1', 'Norway 2'],
    manufacturerName: 'ASIC',
    ths: 150,
    wattage: 3500
  },
  {
    name: 'Bitmain Antminer S19 Pro',
    id: '6',
    price: 540.9,
    setupCosts: 70,
    isInStock: true,
    quantityInStock: 934,
    files: [{ id: 1, src: product2 }],
    locations: ['Norway 1', 'Norway 2'],
    manufacturerName: 'ASIC',
    ths: 150,
    wattage: 3500
  }
];
